import { createElement, Component } from 'react';
import { DropTarget } from 'react-dnd';
import { DropTargetSpec } from 'react-dnd';
import { ItemTypes } from '../Constants';
import { DropTargetConnector } from 'react-dnd/lib/interfaces';
import { DropTargetMonitor } from 'react-dnd/lib/interfaces';
import { ConnectDropTarget } from 'react-dnd/lib/interfaces';
import { store } from '../store';
import { ComponentDesc } from '../store';
import ComponentWrapper from './ComponentWrapper';
import { observer } from 'mobx-react';
import AddRowComponent from '../components/addRowDiv';

const Card = ComponentWrapper(ItemTypes.COMPONENT);

interface Props {
    connectDropTarget?: ConnectDropTarget;
    // You can ask the monitor about the current drag state:
    isOver?: boolean;
    isOverCurrent?: boolean;
    canDrop?: boolean;
    itemType?: string;

    components: ComponentDesc<any>[];
}

class Container extends Component<Props, any> {
    findCard = (id) => {
        const cards = this.props.components;
        const card = cards.filter((c) => c.id === id)[0];

        return {
            card,
            index: cards.indexOf(card),
        };
    };

    moveCard = (id, atIndex) => {
        const { card, index } = this.findCard(id);
        if (card) {
            let newcards = this.props.components;
            console.log('container: moveCard: ', id, atIndex);
            newcards.splice(index, 1); // removing what you are dragging.
            newcards.splice(atIndex, 0, card); // inserting it into hoverIndex.
        }
    };

    removeCard = (id) => {
        const { card, index } = this.findCard(id);
        if (card) {
            this.props.components.splice(index, 1);
            store.ui.left_panel_view = store.ui.prev_view;
        }
    };

    cloneCard = (descriptor) => {
        const { card, index } = this.findCard(descriptor.id);
        if (card) {
            let copy = JSON.parse(JSON.stringify(descriptor));
            copy.id = +new Date();
            this.props.components.splice(index, 0, copy);
        }
    };

    render() {
        const { isOver, canDrop, connectDropTarget, isOverCurrent } = this.props;
        if (!connectDropTarget) return null;

        return connectDropTarget(
            <div
                className={'column-drop-target'}
                style={{
                    minHeight: '100px',
                }}>
                {(this.props.components || []).map((c: ComponentDesc<any>, idx) => {
                    let token = store.getComponentTokenByName(c.type);
                    let C = token.screenComponent;
                    return <Card moveCard={this.moveCard} findCard={this.findCard} removeCard={this.removeCard} cloneCard={this.cloneCard} index={idx} id={c.id} type={c.type} component={C} key={c.type + '_' + idx} descriptor={c} />;
                })}

                <AddRowComponent element="element" type="component" targetArray={this.props.components} targetIndex={this.props.components.length} />
            </div>
        );
    }
}

const targetSpec: DropTargetSpec<Props> = {
    drop(props, monitor, component) {
        if (monitor.didDrop()) {
            // If you want, you can check whether some nested
            // target already handled drop
            return;
        }

        // Obtain the dragged item
        const item = monitor.getItem();

        if (props.components.filter((c) => c.id === item.id).length === 0) {
            console.log('dropped on container, pushing, ', item, component);
            if (!item.id) {
                item.id = +new Date();
            } else {
                store.removeComponentFromPage(item.id);
            }
            props.components.push(item);
            return item;
        }

        return;
    },

    canDrop(props, monitor) {
        return true;
    },
};

function collect(connect: DropTargetConnector, monitor: DropTargetMonitor) {
    return {
        // Call this function inside render()
        // to let React DnD handle the drag events:
        connectDropTarget: connect.dropTarget(),
        // You can ask the monitor about the current drag state:
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: true }),
        canDrop: monitor.canDrop(),
        itemType: monitor.getItemType(),
    };
}

export default DropTarget(ItemTypes.COMPONENT, targetSpec, collect)(observer(Container));
